<div
  *ngIf="
    saleItem.subscriptionId
      ? (saleItem | getSaleItemSubscriptionPrice | async)
      : saleItem.courseId
        ? (saleItem | getSaleItemCoursePrice | async)
        : saleItem.rentalId
          ? (saleItem | getSaleItemRentalProductPrice | async)
          : (saleItem | getSaleItemProductPrice | async) as saleItemPriceDetails
  "
  data-test-id="price-and-quantity-sale-items-invites"
>
  <ng-container *ngIf="shouldShowPrimaryPriceLine(saleItemPriceDetails)">
    <p class="m-0">
      {{ saleItemPriceDetails.price | currency }} ×
      {{ saleItemPriceDetails.qty }}
    </p>
  </ng-container>
  <ng-container *ngIf="shouldShowMemberPriceLine(saleItemPriceDetails)">
    <p class="m-0">
      {{ saleItemPriceDetails.memberPrice | currency }} ×
      {{ saleItemPriceDetails.memberQty }}
    </p>
  </ng-container>
  <ng-container *ngIf="saleItemPriceDetails.familyPriceDetails?.length > 0">
    <p
      class="m-0"
      *ngFor="let familyPriceDetail of saleItemPriceDetails.familyPriceDetails"
    >
      {{ familyPriceDetail.price | currency }} × {{ familyPriceDetail.qty }} ({{
        familyPriceDetail.name
      }})
    </p>
  </ng-container>
  <ng-container *ngIf="saleItemPriceDetails.guestPrice > 0">
    <p class="m-0">
      {{ saleItemPriceDetails.guestPrice | currency }} ×
      {{ saleItemPriceDetails.guestQty }} ({{
        'productModule.guests' | translate
      }})
    </p>
  </ng-container>
  <ng-container *ngIf="saleItemPriceDetails.otherPrice > 0">
    <p class="m-0">
      {{ saleItemPriceDetails.otherPrice | currency }} ×
      {{ saleItemPriceDetails.otherQty }} ({{
        'productModule.chaperones' | translate
      }})
    </p>
  </ng-container>
  <ng-container *ngIf="saleItemPriceDetails.categoryQty > 0">
    <p class="m-0">
      {{ saleItemPriceDetails.categoryGuestPrice | currency }} ×
      {{ saleItemPriceDetails.categoryQty }} ({{
        configurationService.categoryDescriptionByCategory(
          saleItemPriceDetails.category,
          saleItem.siteId
        )
          | async
          | stripHtmlTags
      }})
    </p>
  </ng-container>
</div>
